<template>
  <TimeslotDashboardLayout>
    <div
      :class="
        userInfo.userRole === 'PROFESSIONAL' || customerToProfessionalId
          ? 'main-content payment'
          : 'main-content'
      "
    >
      <div class="welcome-wrappr">
        <div class="text-block-13">Wallet</div>
      </div>
      <div class="wallet-top-details">
        <div class="balance-wrapper">
          <div class="balance-details">
            <div class="total-balance-text-2">Total Balance<br />‍</div>
            <div class="amount">
              <span class="text-span-3">${{ walletInfo.accountBalance }}</span>
            </div>
          </div>
          <div class="professional-wallet-btn-holder">
            <div
              data-w-id="f232bf05-cbdd-9c52-2bb2-daccad536b7e"
              class="withdraw-button w-button"
              @click="openFundWallet"
            >
              Fund wallet
            </div>
            <div
              data-w-id="f232bf05-cbdd-9c52-2bb2-daccad536b7e"
              class="withdraw-button w-button"
              @click="openFund"
              v-if="
                userInfo.userRole === 'PROFESSIONAL' || customerToProfessionalId
              "
            >
              Withdraw Earnings
            </div>
          </div>
        </div>
        <div class="recent">
          <div class="recent-transactions">Recent transactions<br />‍</div>
        </div>
      </div>
      <BaseComponentLoader
        v-if="loader.nonBlockingLoader"
        loaderAlignment="center"
      />
      <div class="recent-transactions-wrapper-2" v-else>
        <div v-if="walletInfo.transactions.length > 0">
          <div
            :class="
              transaction.drCr === 'CR'
                ? 'funding-details _1'
                : 'funding-details_new'
            "
            v-for="(transaction, index) in walletInfo.transactions"
            :key="index"
          >
            <div class="wallet-funded_details">
              <div class="funded">
                <div class="funded_wallet">{{ transaction.narration }}</div>
                <div class="amount-funded">${{ transaction.amount }}</div>
              </div>
              <div class="date-funded">
                <div class="date_funded">{{ transaction.transactionDate }}</div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="empty-message-container">
          <img
            src="@/assets/timeslot-images/wallet-blue-fill.svg"
            width="50"
            height="50"
          />
          <div class="new-message">Nothing to show here</div>
          <div class="new-message-sub">
            Recent transactions <br />
            would show up here
          </div>
        </div>
      </div>
    </div>
    <WithdrawModal v-if="fund" :cancel="closeFund" :close-modal="closeFund" />
    <FundWalletModal v-if="fundWallet" :cancel="closeFundWallet" />
  </TimeslotDashboardLayout>
</template>

<script>
import TimeslotDashboardLayout from "@/views/timeslot/TimeslotDashboardLayout";
import { mapState } from "vuex";
import WalletRequest from "@/model/requests/WalletRequest";
import StoreUtils from "@/utils/BaseUtils/StoreUtils";
import BaseComponentLoader from "@/components/BaseComponents/BaseComponentLoader";
import RouterUtils from "@/utils/BaseUtils/RouterUtils";
import WithdrawModal from "@/components/modal/WithdrawModal";
import FundWalletModal from "@/components/modal/FundWalletModal";
export default {
  name: "ProfessionalWallet",
  components: {
    FundWalletModal,
    WithdrawModal,
    TimeslotDashboardLayout,
    // ProfessionalAppNavBar,
    // ProfessionalSidebar,
    BaseComponentLoader
  },
  data() {
    return {
      share: false,
      bar: true,
      cross: false,
      readModel: WalletRequest.balanceEnquiry,
      recentModel: WalletRequest.recentTransactions,
      readAllModel: WalletRequest.read,
      fund: false,
      fundWallet: false,
      flutterwaveVerifyModel: WalletRequest.flutterwaveVerify
    };
  },
  computed: {
    ...mapState({
      userInfo: state => state.auth.userInfo,
      walletInfo: state => state.wallet.walletInfo,
      balanceInfo: state => state.wallet.balanceInfo,
      recentTransactions: state => state.wallet.recentTransactions,
      professionalId: state => state.professional.professionalId,
      customerInfo: state => state.customer.customerInfo,
      customerToProfessionalId: state =>
        state.professional.customerToProfessionalId
    }),
    ...mapState(["loader"])
  },
  methods: {
    showNav() {
      this.cross = true;
      this.bar = false;
    },
    closeNav() {
      this.bar = true;
      this.cross = false;
    },
    goToProfile() {
      let professionalId;
      if (this.userInfo.professional.professionalId) {
        professionalId = this.userInfo.professional.professionalId;
      } else {
        professionalId = this.customerToProfessionalId;
      }
      RouterUtils.changeRouteUrlTo(`/professionals/${professionalId}`);
    },
    openFund() {
      this.fund = true;
    },
    closeFund() {
      this.fund = false;
    },
    openFundWallet() {
      this.fundWallet = true;
    },
    closeFundWallet() {
      this.fundWallet = false;
    }
  },
  beforeMount() {
    this.readAllModel.customerId = this.userInfo.customerId;

    StoreUtils.dispatch("wallet/readWallet", this.readAllModel);

    let urlParams = new URLSearchParams(window.location.search);
    let myParam = urlParams.get("transaction_id");
    let id = myParam;
    this.flutterwaveVerifyModel.id = id;
    StoreUtils.dispatch(
      "wallet/flutterwaveVerify",
      this.flutterwaveVerifyModel
    ).then(() => {
      this.readAllModel.customerId = this.userInfo.customerId;
      StoreUtils.dispatch("wallet/readWallet", this.readAllModel);
    });
    // if (this.$route.params.transaction_id) {
    //   let trans_id = this.$route.params.transaction_id;
    //   this.flutterwaveVerifyModel.id = trans_id;
    //   StoreUtils.dispatch(
    //     "wallet/flutterwaveVerify",
    //     this.flutterwaveVerifyModel
    //   );
    // }
  }
};
</script>

<style scoped>
.professional-wallet-btn-holder {
  display: flex;
  gap: 10px;
}
</style>
